import { render, staticRenderFns } from "./ProfileSection.vue?vue&type=template&id=3ff7af58&scoped=true&"
import script from "./ProfileSection.vue?vue&type=script&lang=js&"
export * from "./ProfileSection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileSection.vue?vue&type=style&index=0&id=3ff7af58&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff7af58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3ff7af58')) {
      api.createRecord('3ff7af58', component.options)
    } else {
      api.reload('3ff7af58', component.options)
    }
    module.hot.accept("./ProfileSection.vue?vue&type=template&id=3ff7af58&scoped=true&", function () {
      api.rerender('3ff7af58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/profile/form/components/ProfileSection.vue"
export default component.exports